import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import API from "../../../Common/API";
import { motion } from "framer-motion";
import profession from "../../../Assets/Icons/profession.svg";
import income from "../../../Assets/Icons/income.svg";
import date from "../../../Assets/Icons/date.svg";
import stars from "../../../Assets/Icons/star.svg";
import workLocation from "../../../Assets/Icons/workLocation.svg";
import flawsIcon from "../../../Assets/Icons/flaws.svg";
import { FaGraduationCap } from "react-icons/fa6";
import { TbZodiacCancer } from "react-icons/tb";
import RasiKattam from "../../../Components/RasiKattam";
import AmsaKattam from "../../../Components/AmsaKattam";
import Button from "../../../Components/Button";
import PreviewProfileLoader from "../../../Components/Loaders/PreviewProfileLoader";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../../Store/Theme/actions";
import Dialog from "../../../Components/Dialog";
import { setCountApi } from "../../../Store/Auth/actions";
import { useTranslation } from "react-i18next";
import dummy from "../../../Assets/Images/dummy.jpg.webp";
import { useHistory } from "react-router-dom";
import html2pdf from "html2pdf.js";
import PrintUser from "./PrintUser";

const PreviewUser = ({ userValues, registration = false }) => {
  const userDetails = userValues;
  const loggedInUser = useSelector((state) => state.auth.userDetails);
  const educationList = useSelector((state) => state.auth.educationList);
  const zodiacSigns = useSelector((state) => state.auth.zodiacSigns);
  const flaws = useSelector((state) => state.auth.flaws);
  const occupation = useSelector((state) => state.auth.fullOccupations);
  const allStars = useSelector((state) => state.auth.allStars);
  const status = useSelector((state) => state.auth.status);
  const tStatus = useSelector((state) => state.auth.tStatus);
  const tFlaws = useSelector((state) => state.auth.tFlaws);
  const tOccupation = useSelector((state) => state.auth.tOccupation);
  const [loading, setLoading] = useState(true);
  const countApi = useSelector((state) => state.auth.countApi);
  const [downloadConfirm, setDownloadConfirm] = useState(false);
  const dispatch = useDispatch();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const lang = useSelector((state) => state.theme.language);
  const dhisas = useSelector((state) => state.auth.dhisa);
  const { t } = useTranslation();
  const history = useHistory();
  const ownId = useSelector((state) => state.auth.userDetails._id);

  const printRef = useRef();

  // const handlePrint = async () => {
  //     const element = printRef.current;

  //     // Create watermark overlay
  //     const watermark = document.createElement("div");
  //     watermark.textContent = "royalkavery";
  //     Object.assign(watermark.style, {
  //         position: "absolute",
  //         top: "40%",
  //         left: "20%",
  //         fontSize: "48px",
  //         color: "rgba(0,0,0,0.1)",
  //         transform: "rotate(-45deg)",
  //         pointerEvents: "none",
  //         zIndex: 9999,
  //         width: "100%",
  //         textAlign: "center",
  //         whiteSpace: "nowrap"
  //     });
  //     element.appendChild(watermark);

  //     const canvas = await html2canvas(element, {
  //         scale: 2,
  //         useCORS: true
  //     });

  //     element.removeChild(watermark); // Remove watermark from the DOM after capture

  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'pt', 'a4');
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //     pdf.save("profile.pdf");
  // };

  useEffect(() => {
    try {
      // axios.all([API.get('/common/getEducations'), API.get('/common/getZodiacSign'), API.get('/common/getAllFlaws'), API.get('/common/getStatusList'), API.get('/common/getOccupations'), API.get('/common/getAllStars')]).then((axios.spread((eduRes, zodiacRes, flawRes, statRes, occuRes, starRes) => {
      // setEducationList(eduRes.data.data.map((c) => { return { text: `${c.education} ${c.specialization !== null ? `- ${c.specialization}` : ''}`, value: c._id } }))
      // setFullEducations(eduRes.data.data)
      // setZodiacSigns(zodiacRes.data.data.map((c) => { return { text: `${c.zodiacSign}`, value: c._id } }))
      // setFlaws(flawRes.data.data.map((c) => { return { text: c.flawName, value: c._id } }))
      // setStatus(statRes.data.data.map((c) => { return { text: c.status, value: c._id } }))
      // setOccupation(occuRes.data.data)
      // setAllStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
      setLoading(false);
      // })))
    } catch (err) {
      console.log(err);
    }
  }, []);

  const calculateAge = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // If birth month is after current month or same month but birth date is after current date, subtract 1
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const getFlaws = (value) => {
    if (lang === "en") {
      return flaws.filter((x) => x.value === value)[0].text;
    } else {
      return tFlaws.filter((x) => x.value === value)[0].text;
    }
  };

  const getStatus = (value) => {
    if (value.toString().length > 0) {
      if (lang === "en") {
        return status.filter((x) => x.value === value)[0].text;
      } else {
        return tStatus.filter((x) => x.value === value)[0].text;
      }
    }
    return null;
  };

  const getZodiac = (value) => {
    return zodiacSigns.filter((x) => {
      return x.value === value;
    })[0].text;
  };

  const getStars = (value) => {
    return allStars.filter((x) => {
      return x.value === value;
    })[0].text;
  };

  const getQualification = (value) => {
    return educationList.filter((x) => {
      return x.value === value;
    })[0].text;
  };

  const downloadProfile = (value) => {
    setDownloadConfirm(true);
  };

  const confirmDownload = () => {
    setConfirmLoading(true);
    try {
      let apiValues = {
        profileId: userDetails._id,
        addedBy: loggedInUser._id,
      };
      API.post("/user/downloadProfile", apiValues)
        .then((apiRes) => {
          if (apiRes.status === 200) {
            userDetails.isDownloaded = true;
            dispatch(
              setAlert({
                title: "Success",
                subtitle: "Profile Downloaded Successfully",
                type: "success",
                active: true,
              })
            );
            setDownloadConfirm(false);
            setConfirmLoading(false);
            dispatch(setCountApi(countApi + 1));
          }
        })
        .catch((err) => {
          setConfirmLoading(false);
          dispatch(
            setAlert({
              title: "Error",
              subtitle: err.response.data.error,
              type: "error",
              active: true,
            })
          );
        });
    } catch (err) {
      dispatch(
        setAlert({
          title: "Error",
          subtitle: "Something went wrong",
          type: "error",
          active: true,
        })
      );
    }
  };

  const downloadPDF = (refId) => {
    const element = printRef.current;
    const opt = {
      margin: 0.5,
      filename: `${refId}Profile.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: `` },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save();
  };

  const getDhisas = (values) => {
    return values
      ? dhisas.filter((x) => {
          return x.value === parseInt(values);
        })[0].text
      : "-";
  };

  const formatTo12Hour = (time24) => {
    if (!time24) return "";

    const [hour, minute] = time24.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;

    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  };

  const handlePrint = () => {
    window.print();
  };

  const clearHeights = (height) => {
    let input = height;
    let cleaned = input.match(/\d+\s*ft\s*\d*\s*in/);
    return cleaned ? cleaned[0] : "--";
  };

  return (
    <>
      {loading ? (
        <PreviewProfileLoader />
      ) : (
        <motion.div
          id="printable-area"
          className="min-h-screen w-screen flex flex-col relative px-2 py-2"
        >
          {/* Basic Profile Details */}
          {!registration && (
            <div className="no-print">
              <Button
                type={"primary"}
                injectClass={"h-fit rounded-full px-1 w-fit"}
                onClick={() => history.goBack()}
              >
                {t("Back to search")}
              </Button>
            </div>
          )}
          <div className="print:block hidden text-start font-bold text-xl mb-8">
            <div ref={printRef}>
              <PrintUser userDetails={userDetails} />
            </div>
          </div>
          <div className="print:block hidden fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-2/2 -rotate-45 text-[80px] font-bold text-primeColor/10 pointer-events-none select-none z-0 whitespace-nowrap">
            Royal Kavery
          </div>
          <motion.div className="no-print flex flex-col">
            <motion.div className="flex flex-col md:flex-row justify-start gap-5">
              {!registration ? (
                <motion.div className="flex flex-col h-full gap-2 w-fit no-print">
                  <motion.div>
                    {userDetails?.previewUrls && userDetails?.previewUrls[0] ? (
                      <img
                        src={
                          userDetails?.previewUrls.length > 0
                            ? userDetails?.previewUrls[0]?.imageUrl
                            : dummy
                        }
                        height={50}
                        width={50}
                        className="h-64 w-64 object-contain"
                        alt="Preview"
                      />
                    ) : (
                      <img
                        src={dummy}
                        height={100}
                        width={100}
                        className="h-64 w-64 object-contain"
                        alt="Preview"
                      />
                    )}
                  </motion.div>
                  <motion.div className="flex flex-row gap-1 w-80 overflow-x-scroll">
                    <PhotoProvider>
                      {userDetails &&
                        userDetails.previewUrls.map((photo) => {
                          return (
                            <PhotoView src={photo?.imageUrl}>
                              <img
                                src={photo?.imageUrl}
                                alt=""
                                height={50}
                                width={50}
                                className="object-cover cursor-pointer"
                              />
                            </PhotoView>
                          );
                        })}
                    </PhotoProvider>
                  </motion.div>
                </motion.div>
              ) : (
                <motion.div className="flex flex-col h-full gap-2 w-96">
                  <motion.div>
                    {userDetails?.previewUrls &&
                      userDetails?.previewUrls[0] && (
                        <img
                          src={userDetails?.previewUrls[0]}
                          className="h-96 w-96 object-cover"
                          alt="Preview"
                        />
                      )}
                  </motion.div>
                  <motion.div className="flex flex-row gap-1 w-96 overflow-x-scroll">
                    {userDetails?.previewUrls &&
                      userDetails?.previewUrls.map((c) => {
                        return (
                          <img
                            src={c}
                            height={100}
                            width={100}
                            className="object-cover"
                            alt={"Preview"}
                          />
                        );
                      })}
                  </motion.div>
                </motion.div>
              )}
              <motion.div className="flex flex-col md:flex-row justify-between w-full px-1 md:px-5">
                <motion.div className="flex flex-col h-full w-full gap-3">
                  {lang === "en" ? (
                    <p className="text-sm font-bold text-primeColor">
                      {userDetails?.firstName}&nbsp;{userDetails?.lastName} (
                      {userDetails?.surname}){" "}
                    </p>
                  ) : (
                    <p className="text-sm font-bold text-primeColor">
                      {userDetails?.tFirstName}&nbsp;{userDetails?.tLastName} (
                      {userDetails?.tSurname}){" "}
                    </p>
                  )}
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.refId}
                  </p>
                  <p className="flex flex-row flex-wrap text-sm  font-bold justify-start gap-2 items-center">
                    <img src={profession} alt="profession" />
                    {userDetails?.occupationDetail || userDetails?.occupation}
                    <span className="text-greyColor items-center font-bold text-sm">
                      |
                    </span>
                    {calculateAge(userDetails?.dateOfBirth)} {t("Years Old")}{" "}
                    <span className="text-greyColor items-center font-bold text-sm">
                      |
                    </span>
                    {!registration
                      ? clearHeights(userDetails?.heightInFeet)
                      : clearHeights(
                          `${userDetails?.heightInFeet.split(".")[0]} ft ${
                            userDetails?.heightInFeet.split(".")[1]
                          } in`
                        ) || "-"}
                  </p>
                  {!registration && (
                    <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                      <img src={date} alt="income" height={30} width={30} />
                      {t("Date Of Birth")}
                      <span className="text-primeColor items-center font-bold text-sm">
                        {userDetails?.date +
                          "/" +
                          userDetails?.month +
                          "/" +
                          userDetails?.year}
                      </span>
                    </p>
                  )}
                  {registration && (
                    <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                      <img src={date} alt="income" height={30} width={30} />
                      {t("Date Of Birth")}
                      <span className="text-primeColor items-center font-bold text-sm">
                        {userDetails?.dateOfBirth.split("-")[2] +
                          "/" +
                          userDetails?.dateOfBirth.split("-")[1] +
                          "/" +
                          userDetails?.dateOfBirth.split("-")[0]}
                      </span>
                    </p>
                  )}
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    <img src={income} alt="income" height={30} width={30} />
                    {t("Income")}/
                    {userDetails?.salaryMode
                      ? t(`${userDetails?.salaryMode}`)
                      : "Month"}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {userDetails?.salary}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <FaGraduationCap className="mx-1" size={20} />
                    {t("Qualification")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {userDetails?.otherEducationalQualification}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    <img
                      src={workLocation}
                      alt="building"
                      height={30}
                      width={30}
                    />
                    {t("Work Location")}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {userDetails?.occupationLocation || "--"}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <TbZodiacCancer className="mx-1" size={20} />
                    {t("Zodiac Sign")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {
                        zodiacSigns?.filter(
                          (x) =>
                            x.value ===
                            userDetails?.additionalInformation?.zodiacSign
                        )[0].text
                      }
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <img
                      src={stars}
                      alt="workLocatino"
                      height={30}
                      width={30}
                    />
                    {t("Star")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {userDetails?.additionalInformation?.star
                        ? allStars?.filter(
                            (x) =>
                              x.value ===
                              userDetails?.additionalInformation?.star
                          )[0]?.text
                        : "-"}
                    </span>
                    <span className="text-primeColor font-bold">
                      {userDetails?.additionalInformation?.padham || "--"}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <img
                      src={flawsIcon}
                      alt="workLocatino"
                      height={30}
                      width={30}
                    />
                    {t("Flaws")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {userDetails?.additionalInformation?.flaws?.length > 0
                        ? userDetails?.additionalInformation?.flaws?.map((c) => {
                            return getFlaws(c);
                          })
                        : "-"}
                    </span>
                  </p>
                </motion.div>
                {!registration && (
                  <motion.div className="no-print flex flex-col justify-center w-full h-full">
                    {!userDetails?.isDownloaded && userDetails?._id !== ownId && (
                      <motion.div
                        className="flex flex-row items-center text-sm"
                        onClick={() => downloadProfile(userDetails)}
                      >
                        <Button type={"primary"} injectClass={"w-fit"}>
                          {t("View Contact Information")}
                        </Button>
                      </motion.div>
                    )}
                    <motion.div
                      className="flex flex-row items-center text-sm"
                      onClick={() => handlePrint()}
                    >
                      <Button type={"primary"} injectClass={"w-fit"}>
                        {t("Print Profile")}
                      </Button>
                    </motion.div>
                    {/* <motion.div className="flex flex-row items-center" onClick={() => downloadPDF(userDetails.refId)}>
                                        <Button type={'primary'} injectClass={'w-fit'}>{t('Download Profile')}</Button>
                                    </motion.div> */}
                  </motion.div>
                )}
              </motion.div>
            </motion.div>
            <motion.div className="flex flex-col lg:flex-row flex-wrap justify-start gap-4 px-2 md:px-5 w-full my-5">
              {/* Family Information */}
              <motion.div className="flex flex-col gap-5 w-full lg:w-fit px-2 py-2">
                <p className="text-lg font-bold text-primeColor">
                  {t("Family Information")}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-2">
                  <p className="text-sm">{t("Father name")}</p>
                  {lang === "en" && (
                    <p className="text-sm font-bold text-primeColor">
                      {userDetails?.familyInformation?.fatherFirstName}&nbsp;(
                      {userDetails?.familyInformation?.fatherSurname})
                    </p>
                  )}
                  {lang === "ta" && (
                    <p className="text-sm font-bold text-primeColor">
                      {userDetails?.familyInformation?.tFatherFirstName ||
                        userDetails?.familyInformation?.fatherFirstName}
                      &nbsp;(
                      {userDetails?.familyInformation?.tFatherSurname ||
                        userDetails?.familyInformation?.fatherSurname}
                      )
                    </p>
                  )}
                  <p className="text-sm">{t("Father Occupation")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.fatherOccupation || "-"}
                  </p>

                  <p className="text-sm">{t("Father Native")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.fatherNative || "-"}
                  </p>

                  <p className="text-sm">{t("Mother name")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.motherFirstName}&nbsp;(
                    {userDetails?.familyInformation?.motherSurname})
                  </p>

                  <p className="text-sm">{t("Mother Occupation")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.motherOccupation || "-"}
                  </p>

                  <p className="text-sm">{t("Mother Native")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.motherNative || "-"}
                  </p>

                  <p className="text-sm">{t("Male Siblings")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.numberOfMaleSiblings}
                  </p>

                  <p className="text-sm">{t("Female Siblings")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.numberOfFemaleSiblings}
                  </p>

                  <p className="text-sm">{t("Married Male Siblings")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.marriedMaleSiblings}
                  </p>

                  <p className="text-sm">{t("Married Female Siblings")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.marriedFemaleSiblings}
                  </p>

                  <p className="text-sm">{t("Siblings Details")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.familyInformation?.siblingsDetails}
                  </p>
                </div>
              </motion.div>

              {/* Divider */}
              <div className="hidden lg:block h-auto w-[1px] bg-primeColor"></div>

              {/* Contact Information */}
              <motion.div className="flex flex-col gap-5 w-full lg:w-fit px-2 py-2">
                <p className="text-lg font-bold text-primeColor">
                  {t("Contact Information")}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  <p className="text-sm">{t("Phone Number")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.isDownloaded || userDetails?._id === ownId
                      ? userDetails?.contactInformation?.mobileNumber
                      : "**********"}
                  </p>

                  <p className="text-sm">{t("Email Id")}</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.isDownloaded || userDetails?._id === ownId
                      ? userDetails?.contactInformation?.email || "-"
                      : "**************"}
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  <p className="text-sm">{t("Present Address")}</p>
                  <div className="text-sm font-bold text-primeColor space-y-1">
                    {userDetails?.isDownloaded || userDetails?._id === ownId ? (
                      <>
                        <p>
                          {userDetails?.contactInformation?.presentAddress
                            ?.addressLine1 || "--"}
                        </p>
                        {userDetails?.contactInformation?.presentAddress
                          ?.addressLine2 && (
                          <p>
                            {
                              userDetails?.contactInformation?.presentAddress
                                ?.addressLine2
                            }
                          </p>
                        )}
                        <p>
                          {userDetails?.contactInformation?.presentAddress
                            ?.city || "--"}
                        </p>
                        <p>
                          {userDetails?.contactInformation?.presentAddress
                            ?.district || "--"}{" "}
                          -{" "}
                          {userDetails?.contactInformation?.presentAddress
                            ?.pinCode || "--"}
                        </p>
                        <p>
                          {userDetails?.contactInformation?.presentAddress
                            ?.state || "--"}
                        </p>
                      </>
                    ) : (
                      <p>{"**********************"}</p>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  <p className="text-sm">{t("Native Address")}</p>
                  <div className="text-sm font-bold text-primeColor space-y-1">
                    {userDetails?.isDownloaded || userDetails?._id === ownId ? (
                      <>
                        <p>
                          {userDetails?.contactInformation?.nativeAddress
                            ?.addressLine1 || "--"}
                        </p>
                        {userDetails?.contactInformation?.nativeAddress
                          ?.addressLine2 && (
                          <p>
                            {
                              userDetails?.contactInformation?.nativeAddress
                                ?.addressLine2
                            }
                          </p>
                        )}
                        <p>
                          {userDetails?.contactInformation?.nativeAddress
                            ?.city || "--"}
                        </p>
                        <p>
                          {userDetails?.contactInformation?.nativeAddress
                            ?.district || "--"}{" "}
                          -{" "}
                          {userDetails?.contactInformation?.nativeAddress
                            ?.pinCode || "--"}
                        </p>
                        <p>
                          {userDetails?.contactInformation?.nativeAddress
                            ?.state || "--"}
                        </p>
                      </>
                    ) : (
                      <p>{"**********************"}</p>
                    )}
                  </div>
                </div>
              </motion.div>

              {/* Divider */}
              <div className="hidden lg:block h-auto w-[1px] bg-primeColor"></div>

              {/* Expected Information */}
              <motion.div className="flex flex-col flex-wrap gap-5 w-full lg:w-fit no-print px-2 py-2">
                <p className="text-lg font-bold text-primeColor">
                  {t("Expected Information")}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  <p>{t("Income")}</p>
                  <p className="font-bold text-primeColor w-60">
                    {userDetails?.additionalInformation?.expectedSalary || "--"}
                  </p>

                  <p>{t("Status")}</p>
                  <p className="font-bold text-primeColor w-60">
                    {userDetails?.additionalInformation?.expectedStatus
                      ?.length > 0
                      ? userDetails?.additionalInformation?.expectedStatus?.map(
                          (c, i) => (
                            <span key={i}>
                              {getStatus(c)}
                              {i !==
                                userDetails?.additionalInformation
                                  ?.expectedStatus?.length -
                                  1 && ", "}
                            </span>
                          )
                        )
                      : "--"}
                  </p>

                  <p>{t("Zodiac Signs")}</p>
                  <p className="font-bold text-primeColor flex-wrap flex w-60">
                    {userDetails?.additionalInformation?.expectedZodiacSigns
                      ?.length > 0
                      ? userDetails?.additionalInformation?.expectedZodiacSigns?.map(
                          (c, i) => (
                            <span key={i}>
                              {getZodiac(c)}
                              {i !==
                                userDetails?.additionalInformation
                                  ?.expectedZodiacSigns?.length -
                                  1 && ", "}
                            </span>
                          )
                        )
                      : "--"}
                  </p>

                  <p>{t("Stars")}</p>
                  <p className="font-bold text-primeColor w-60">
                    {userDetails?.additionalInformation?.expectedStars?.length >
                    0
                      ? userDetails?.additionalInformation?.expectedStars?.map(
                          (c, i) => (
                            <span key={i}>
                              {getStars(c)}
                              {i !==
                                userDetails?.additionalInformation
                                  ?.expectedStars?.length -
                                  1 && ", "}
                            </span>
                          )
                        )
                      : "--"}
                  </p>

                  <p>{t("Expectations")}</p>
                  <p className="font-bold text-sm text-primeColor w-60">
                    {userDetails?.additionalInformation?.expectation || "---"}
                  </p>

                  <p>{t("Asset Information")}</p>
                  <p className="font-bold text-sm text-primeColor w-60">
                    {userDetails?.familyInformation?.assetInfo}
                  </p>
                </div>
              </motion.div>
            </motion.div>
            <motion.div className="flex flex-col gap-5 w-full px-2 py-2 relative">
              <p className="text-xl font-bold text-primeColor">
                {t("Birth Information")}
              </p>

              {/* Responsive wrapper */}
              <motion.div className="flex flex-col sm:flex-row sm:flex-wrap gap-5">
                {/* Individual Info Blocks */}
                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2">
                  <p className="text-sm">{t("Birth Time")} :</p>
                  <p className="text-sm font-bold text-primeColor">
                    {formatTo12Hour(userDetails?.birthTime)}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2">
                  <p className="text-sm">{t("Birth Place")} :</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.birthPlace}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2">
                  <p className="text-sm">{t("Dhisai Iruppu")} :</p>
                  <p className="text-sm font-bold text-primeColor">
                    {getDhisas(userDetails?.thisaiIruppu) || "-"}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2">
                  <p className="text-sm">{t("Dhisai Iruppu Date")} :</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.thisaiIruppuDate}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2">
                  <p className="text-sm">{t("Dhisai Iruppu Month")} :</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.thisaiIruppuMonth}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2">
                  <p className="text-sm">{t("Dhisai Iruppu Year")} :</p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.thisaiIruppuYear}
                  </p>
                </motion.div>
              </motion.div>
            </motion.div>
            {
              <motion.div className="h-full flex flex-col md:flex-row min-w-screen py-2 justify-between child-wrapper md:px-20 gap-2 my-2">
                <div className="rasi-chart print:scale-[0.6] print:mt-4">
                  {!registration && (
                    <RasiKattam
                      kattamOuterInjectClass={`h-[300px] w-[300px] md:h-[400px] md:w-[400px]`}
                      kattamInnerInjectclass={
                        "h-[75px] w-[75px] md:h-[100px] md:w-[100px]"
                      }
                      readOnly={true}
                      rasiValues={userDetails?.rasiKattam?.rasiPlanets}
                    />
                  )}
                  {registration && (
                    <RasiKattam
                      kattamOuterInjectClass={`h-[400px] w-[400px]`}
                      kattamInnerInjectclass={"h-[100px] w-[100px]"}
                      rasiValues={userDetails?.rasiKattam}
                      readOnly={true}
                    />
                  )}
                </div>
                <div className="amsa-chart print:scale-[0.6] print:mt-4">
                  {!registration && (
                    <AmsaKattam
                      kattamOuterInjectClass={`h-[300px] w-[300px] md:h-[400px] md:w-[400px]`}
                      kattamInnerInjectclass={
                        "h-[75px] w-[75px] md:h-[100px] md:w-[100px]"
                      }
                      readOnly={true}
                      amsaValues={userDetails?.amsaKattam?.amsaPlanets}
                    />
                  )}
                  {registration && (
                    <AmsaKattam
                      kattamOuterInjectClass={`h-[400px] w-[400px]`}
                      kattamInnerInjectclass={"h-[100px] w-[100px]"}
                      amsaValues={userDetails?.amsaKattam}
                      readOnly={true}
                    />
                  )}
                </div>
              </motion.div>
            }
          </motion.div>
        </motion.div>
      )}
      <Dialog
        title={"Download Confirm"}
        showDialog={downloadConfirm}
        onClose={() => {
          setDownloadConfirm(false);
        }}
      >
        <motion.div className="h-full w-full flex flex-col gap-5 px-2 py-2">
          <p>Are you sure you want to download this profile?</p>
          <motion.div className="flex justify-center gap-2">
            <Button
              type="primary"
              disabled={confirmLoading}
              injectClass="rounded-md"
              onClick={() => !confirmLoading && confirmDownload()}
            >
              Yes
            </Button>
            <Button
              type="secondary"
              injectClass="rounded-md"
              onClick={() => {
                setDownloadConfirm(false);
              }}
            >
              No
            </Button>
          </motion.div>
        </motion.div>
      </Dialog>
    </>
  );
};

export default PreviewUser;
